import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAppStore } from '../../stores/useAppStore';
import { useAuthStore } from '../../stores/useAuthStore';
import './Header.css';

export function Header() {
  const { t } = useTranslation();
  const { settings } = useAppStore();
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.token);

  const botLink = settings['bot_link'] || '#';

  return (
    <header className="header">
      <div className="header__container">
        <a href="/" className="header__logo">
          <span className="header__logo-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
              <rect width="24" height="24" rx="6" fill="url(#logo-grad)" />
              <path d="M7 8.5h10M7 12h7M7 15.5h10" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
              <path d="M16 10l2 2-2 2" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
              <defs>
                <linearGradient id="logo-grad" x1="0" y1="0" x2="24" y2="24">
                  <stop stopColor="#26a17b" />
                  <stop offset="1" stopColor="#50e3c2" />
                </linearGradient>
              </defs>
            </svg>
          </span>
          <span className="header__logo-text">
            RubEx
            <span className="header__logo-subtext"> change</span>
          </span>
        </a>

        <div className="header__actions">
          {token && user ? (
            <Link to="/account" className="header__btn">
              {user.email || 'Кабинет'}
              {!user.is_fully_verified && <span className="header__alert-dot" />}
            </Link>
          ) : (
            <Link to="/login" className="header__btn">
              Войти
            </Link>
          )}

          {botLink !== '#' && (
            <a
              href={botLink}
              target="_blank"
              rel="noopener noreferrer"
              className="header__btn header__btn--primary"
            >
              {t('header.goToBot')}
            </a>
          )}
        </div>
      </div>
    </header>
  );
}
